module.exports = __webpack_public_path__ + "img/bobIcon.e04d13b0.svg";